<mat-form-field fxFlex>
	<input type="text" [placeholder]="placeholder" aria-label="Number" matInput [matAutocomplete]="auto"
		[(ngModel)]="AutoValue" (ngModelChange)="this.autoUpdate.next($event)">
	<mat-autocomplete #auto="matAutocomplete" (optionSelected)="valueChanged()" [displayWith]="displayFn">
		<mat-option *ngFor="let option of optionsAuto" [value]="option">
			{{option[key]}}
		</mat-option>
	</mat-autocomplete>
</mat-form-field>